module.exports = __webpack_public_path__ + "img/Scenarios_Weak_Economy.bd699faf.jpg";